module.exports = " <div class=row> <div class=\"col-xs-12 col-sm-12 col-md-12\"> <div class=pageFooter__utilNav> <a href=http://www.genkosha.co.jp/privacy/ >プライバシーポリシー</a> | <a href=http://www.genkosha.co.jp/company/ >運営会社</a> </div> <small class=pageFooter__copyright>Copyright &copy; 1999-2016 GENKOSHA Co. All rights reserved</small> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/footer.vue
// module id = 234
// module chunks = 3